import styled from 'styled-components';
import { ASSETS } from '../../../../../assets';

export const SlothIcon = styled(ASSETS.SLOTH_ON_TREE)`
  margin-left: -115px;
`;

export const LianaIcon = styled(ASSETS.LIANA)`
  position: absolute;
  top: 0;
  left: 0;
`;
